import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output, Renderer2 } from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import { ToggleItem } from './toggle-item';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ToggleControlComponent),
    multi: true
};

@Component({
    selector: 'toggle-control',
    templateUrl: './toggle-control.component.html',
    styleUrls: ['./toggle-control.component.less'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR,

        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ToggleControlComponent),
            multi: true
        }

    ]
})

export class ToggleControlComponent implements ControlValueAccessor {

    @Input()
    items: Array<ToggleItem> = [];

    @Input()
    defaultValue: string = "";

    @Input()
    itemSpace: number = 10;

    @Input()
    itemTopSpace: number = 10;

    @Input()
    wrapItems: boolean = true;

    @Output()
    private beforeSelect = new EventEmitter<any>();

    @Output()
    private select = new EventEmitter<any>();

    @Output()
    private change = new EventEmitter<any>();

    private _value: string = '';

    disabled: boolean = false;

    private inClickHandler: boolean = false;

    constructor(private el: ElementRef,
        private r: Renderer2,
        private chDet: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this._value = this.defaultValue;
        this.handleChange();
        if (this.wrapItems)  this.r.setStyle(this.el.nativeElement, 'max-height', this.items.length * (30 + this.itemTopSpace) + 'px');
        else this.r.setStyle(this.el.nativeElement, 'height', (30 + this.itemTopSpace) + 'px');
    }

    ngAfterViewInit(): void {}
    handleChange(): void {}

    onSelect(item: ToggleItem): void {
        this.inClickHandler = true;
        this.beforeSelect.emit();

        this.value = item.getInputValue();

        this.select.emit(this.value);
        this.inClickHandler = false;
    }

    public disable(): void {
        this.disabled = true;
    }

    public enable(): void {
        this.disabled = false;
    }

    public onItemEnter(ev: MouseEvent, item: ToggleItem) {}
    public onItemLeave(ev: MouseEvent, item: ToggleItem) {}

    public isItemActive(item: ToggleItem): boolean {
        if (item.inputValue === this.value) return true;
        return false;
    }

    get value(): any { return this._value; };

    set value(v: any) {
        if ((v !== this._value) && (v != null)) {
            this._value = v;
            this.change.emit(v);
            this.handleChange();
            this.onChange(v);
        }
    }

    validate(c: FormControl<boolean>) {}

    writeValue(value: any) {
        this.value = value;
    }

    onChange = (_: Function) => { };
    onTouched = () => { };
    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }
}